import React from "react";

// this page added here just to ignore the build time error & redirect route to 404 page not found
function PrivacyPolicyPage() {
  return <div />;
}

export default PrivacyPolicyPage;
